<template>
  <div id="form-label">
    <div>
      <h6 class="mt-0">
        {{ title }}
        <b-badge
          v-if="required"
          variant="light-secondary"
        >
          Wajib
        </b-badge>
      </h6>
    </div>
    <div>
      <p
        v-for="(item, index) in description"
        :key="`list-paragraph-${index}`"
      >
        <!-- eslint-disable-next-line vue/no-v-html -->
        <small v-html="item" />
      </p>
    </div>
  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  components: {
    BBadge,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    description: {
      type: Array,
      default: () => ([]),
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
#form-label {
    margin-right: 2.5rem;

    h6 {
        font-weight: bolder;
    }
}
</style>
